import { Dispatch } from 'redux';

import Constants from './constants';

const connect = () => (dispatch: Dispatch) => {
    dispatch(createConnectPending());
};

const connected = () => (dispatch: Dispatch) => {
    dispatch(createConnectSuccess());
};

const disconnected = () => (dispatch: Dispatch) => {
  dispatch(createDisconnectSuccess());
};

const attemptingReconnect = (attempt:number) => (dispatch:Dispatch) => {
    dispatch(createAttemptingReconnectPending(attempt));
};

const reconnectFailed = () => (dispatch:Dispatch) => {
    dispatch(createReconnectFailed());
}

const reconnectSuccess = () => (dispatch:Dispatch) => {
    dispatch(createAttemptingReconnectSuccess());
};

const createConnectPending = () => ({
    type: Constants.CONNECTION_PENDING,
});

const createConnectSuccess = () => ({
    type: Constants.CONNECTION_SUCCESS,
});

const createDisconnectSuccess = () => ({
    type: Constants.DISCONNECT_SUCCESS,
});

const createAttemptingReconnectPending = (attempt:number) => ({
    attempt,
    type: Constants.ATTEMPTING_RECONNECT_PENDING,
});

const createReconnectFailed = () => ({
    type: Constants.ATTEMPTING_RECONNECT_FAILED,
});

const createAttemptingReconnectSuccess = () => ({
    type: Constants.ATTEMPTING_RECONNECT_SUCCESS
});

export default {
    attemptingReconnect,
    connect,
    connected,
    disconnected,
    reconnectFailed,
    reconnectSuccess
};



// WEBPACK FOOTER //
// ./src/redux/modules/connection/actions.ts